// extracted by mini-css-extract-plugin
export default {"area":"DragAndDropArea-module__area--eefcb","title":"DragAndDropArea-module__title--fb783"};